// extracted by mini-css-extract-plugin
module.exports = {"title":"no-report-card_title_3zlkw"};